module.exports = __webpack_public_path__ + "img/pic4.1.fcf238f1.jpg";